import { NewsSectionFieldsFragment } from '../../../@types/generated';
import { centeredMainGridClasses } from '@/styles/grid';
import CardCarousel from '../CardCarousel';
import NewsEntry from './NewsEntry';

type NewsProps = {
  data: NewsSectionFieldsFragment;
};

const News = ({ data }: NewsProps) => {
  const news: Array<React.ReactNode> = [];

  data?.newsEntriesCollection?.items &&
    data.newsEntriesCollection.items.map((item) => {
      data.title && item ? news.push(<NewsEntry sectionTitle={data.title} item={item} />) : null;
    });

  return (
    <div className={centeredMainGridClasses}>
      <CardCarousel cards={news} />
    </div>
  );
};

export default News;
